import { ApiService } from "@/api";

export default {
  UPDATE_USER({ commit }, { id, user }) {
    return ApiService.user.update(id, user).then((user) => {
      commit("SET_USER", user);
    });
  },
  GET_USER({ commit }, id) {
    return ApiService.user.get(id).then((user) => {
      commit("SET_USER", user);
    });
  },
  ADD_USER(context, newUser) {
    return ApiService.user.create(newUser).then((data) => data.id_account);
  },
  DELETE_USER(context, id) {
    return ApiService.user.delete(id);
  },
};
